import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatalayerService } from 'src/services/datalayer.service';

declare const openFeedbackForm: Function;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public today: number = Date.now();
  footerLinks: any = {};
  
  constructor( private datalayerService: DatalayerService,
    public translate: TranslateService
  ) { 
    
  }

  ngOnInit(): void {
    this.footerLinks = {
      aboutLink: this.translate.instant('footer.aboutlink'),
      aboutText: this.translate.instant('footer.about'),

      contactLink: this.translate.instant('footer.contactlink'),
      contactText: this.translate.instant('footer.contactUs'),

      policyLink: this.translate.instant('footer.policylink'),
      policyText: this.translate.instant('footer.policyPermission'),

      privacyLink: this.translate.instant('footer.privacylink'),
      privacyText: this.translate.instant('footer.privacy')
    };
  }

  footerClick(subcatgory: string, link: string, linkText: string): void {
     this.datalayerService.footerClick(subcatgory, link, linkText);
  }

  onNavClicked(navLinkString: string): void {
    if (navLinkString == 'feedback') {
      openFeedbackForm();
      this.footerClick('feedback', this.translate.instant('footer.feedbacklink'), this.translate.instant('footer.feedback'));
    }
  }
}

